import { useCallback, useEffect } from 'react'

import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Modal } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, rem } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import Cookies from 'js-cookie'

import { useCurrentUrl } from 'hooks/useCurrentUrl'

const COOKIE_NAME = 'intro_banner_modal'

export const IntroCarePathModal = ({
  onItemClick,
  hashToShow,
}: {
  onItemClick: (v: string) => void
  hashToShow: string
}) => {
  const [opened, { close, open }] = useDisclosure(false)
  const currentUrl = useCurrentUrl()
  const handleClick = useCallback(() => {
    Cookies.set(COOKIE_NAME, 'true')
    if (hashToShow === encodeURIComponent('ปรึกษาคุณหมอ').toLowerCase()) {
      window.history.replaceState({}, '', window.location.pathname)
      onItemClick(hashToShow)
    }
    close()
  }, [])

  useEffect(() => {
    !Cookies.get(COOKIE_NAME) && open()
  }, [])

  return (
    <Modal
      size={rem(648)}
      opened={opened}
      withCloseButton
      closeButtonProps={
        {
          'data-event-category': 'Service Connection',
          'data-event-action': 'Pop Up - Close',
          'data-event-label': currentUrl,
          sx: () => ({
            '&:focus-visible': {
              outline: 'none',
            },
          }),
        } as any
      }
      overlayProps={
        {
          'data-event-category': 'Service Connection',
          'data-event-action': 'Pop Up - Close',
          'data-event-label': currentUrl,
        } as any
      }
      onClose={handleClick}
      styles={{
        content: {
          position: 'relative',
        },
        header: {
          position: 'absolute',
          right: 0,
          top: 0,
          border: 0,
          background: 'transparent',
          padding: 0,
          '.mantine-CloseButton-root': {
            width: rem(30),
            height: rem(30),
            top: rem(5),
            right: rem(5),
          },
        },
        body: {
          padding: 0,
        },
      }}
    >
      <AspectRatio
        ratio={972 / 681}
        sx={{ cursor: 'pointer' }}
        onClick={handleClick}
      >
        <img
          loading="lazy"
          src={CommonGAssets.getAssetPath('carePath/modal-banner-th.jpg')}
          alt={''}
          data-event-category="Service Connection"
          data-event-action="Pop Up - Click to Image"
          data-event-label={currentUrl}
        />
      </AspectRatio>
    </Modal>
  )
}
